module.exports = __webpack_public_path__ + "img/gy.3ac8d8fb.svg";